// @flow
import * as React from 'react';
import get from 'lodash/get';
import type { intlShape } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import DisambiguationItem from '../item/container';
import styles from './styles';
import messages from './messages';

type Props = {
  intl: intlShape,
  items: Array<Object>,
  showAllItems: boolean,
  isShowed: boolean,
  what: ?string,
  where: ?string,
  onViewMore: Function,
  onOptionSelect: Function,
};

function DisambiguationList({
  intl,
  items,
  what,
  where,
  isShowed,
  showAllItems,
  onOptionSelect,
  onViewMore,
}: Props) {
  if (!isShowed) {
    return null;
  }

  return (
    <ul className="disambiguation-list">
      {where && (
        <p className="title">
          <FormattedMessage {...messages.filterByLocation} />
        </p>
      )}

      {what && (
        <p className="title">
          <FormattedMessage {...messages.filterByProfession} values={{ '%s': what }} />{' '}
        </p>
      )}

      <DisambiguationItem
        item={{
          name: intl.formatMessage(where ? messages.anyProfession : messages.anyLocation),
        }}
        selected
      />

      {items.map(item => (
        <DisambiguationItem key={get(item, 'id')} item={item} onItemClick={onOptionSelect} />
      ))}

      {!showAllItems && (
        <a href="#" className="view-more" onClick={onViewMore}>
          <li>
            {where && <FormattedMessage {...messages.viewMoreProfessions} />}

            {what && <FormattedMessage {...messages.viewMoreLocations} />}

            <span> &raquo; </span>
          </li>
        </a>
      )}

      <style jsx>{styles}</style>
    </ul>
  );
}

DisambiguationList.defaultProps = {
  what: null,
  where: null,
};

export default DisambiguationList;



// WEBPACK FOOTER //
// ./app/common/Lists/DisambiguationList/list/index.js